import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { Button, Form, Row } from "reactstrap";
import generateFormUI from "../../helpers/GenerateFormUI";

const CommonForm = ({
  formConfig,
  initialValues,
  setFormData,
  validationSchema,
  onSubmit,
  isEditMode,
  submitText,
  disabled,
  assignedUser,
  setAssignedUser,
  audioSrc, // Incoming audio file from other pages
}) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const handleFormChange = (updatedValues) => {
    setFormData(updatedValues);
  };

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Row>
        {generateFormUI(
          formConfig,
          formik,
          handleFormChange,
          disabled,
          assignedUser,
          setAssignedUser,
          isEditMode
        )}
      </Row>
      {/* Submit Button */}
      {!disabled && submitText.length>0 && (
        <div className="text-end mt-3">
          <Button type="submit" color="primary">
            {submitText}
          </Button>
        </div>
      )}
    </Form>
  );
};

CommonForm.propTypes = {
  formConfig: PropTypes.array.isRequired,
  initialValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  submitText: PropTypes.string,
  disabled: PropTypes.bool,
  assignedUser: PropTypes.object,
  setAssignedUser: PropTypes.func,
  audioSrc: PropTypes.string,
};

export default CommonForm;
